import React, { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { connectSocket } from "../helper/socket";
import GameLoading from "../components/GameLoading";

export const Auth = ({ unauthorized, onConnection, connectionLost }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const query = useMemo(() => new URLSearchParams(location.search), [location.search]);

    const gameSettings = useSelector((state) => state.gameSettings.data);

    useEffect(() => {
        let accessToken = query.get("access_token");

        if (accessToken) {
            localStorage.setItem("accessToken", accessToken);
        } else {
            accessToken = localStorage.getItem("accessToken");
        }

        const socket = connectSocket(unauthorized, connectionLost, onConnection);
        console.log("Socket connected: ", socket);
    }, [connectionLost, navigate, onConnection, query, unauthorized]);

    // Redirect to game home page when data is successfully fetched
    useEffect(() => {
        if (gameSettings) {
            navigate("/game");
        }
    }, [gameSettings, navigate]);

    return (
        <div className="w-screen h-screen">
            <GameLoading />
        </div>
    );
}
